/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
;(function () {
  document.addEventListener('DOMContentLoaded', function () {
	var count = 0;
    var qikifyInterval = setInterval(function () {
      if (count > 30) clearInterval(qikifyInterval);
      if (document.querySelector('.tmenu_item')) {
       	var header = document.querySelector('#section-header');
        if (header && !header.classList.contains('Header--center')) {
          if (header.classList.contains('Header--inline')) {
            header.classList.remove('Header--inline');
          }
          header.classList.add('Header--center');
        }
        if (document.querySelector('.Header__MainNav .tmenu_app')) {
          document.querySelector('.Header__MainNav .tmenu_app').style = 'opacity: 1 !important';
        }        
        clearInterval(qikifyInterval);
      }
      count++;
    }, 300);
  });
})();